import globalConstant from "constants/globalConstant";
import { MESSAGE_TYPES } from "constants/messageConstants";
import network from "network/network";
import { chatTrace, ensureChatTraceId, resolveChatCustomerNumber } from "utils/chatTrace";
import actionTypes from "./actionTypes";
import { notification } from 'antd';
const { selectChatDetailList, selectChatList } = require("./chatActions");


export function appListener(received) {

    return (dispatch, getState) => {

        try {
            var actionType = "";
            var payload = {};
            var listenerType = received.type;
            var title = "";
            var content = "";

            chatTrace("listener.received", {
                listenerType,
                hasPayload: !!received?.payload
            });

            switch (listenerType) {
                case globalConstant.listenerTypes.inboundmessage:
                    actionType = actionTypes.ON_CHAT_LISTENER;
                    payload = JSON.parse(received.payload);
                    break;
                case globalConstant.listenerTypes.outboundmessage:
                    actionType = actionTypes.ON_CHAT_LISTENER;
                    payload = JSON.parse(received.payload);
                    break;
                case globalConstant.listenerTypes.connectCustomerService:
                    actionType = actionTypes.ON_CUSTOMER_SERVICE_LISTENER;
                    payload = JSON.parse(received.payload);

                    title = "Müşteri Temsilcisine Bağlantı"
                    content = `${payload.sourcePhone} Numaralı telefondan Müşteri temsilcisine bağlantı isteği gelmiştir.`;
                    break;
                case globalConstant.listenerTypes.neworder:
                    actionType = actionTypes.ON_ORDER_LISTENER;
                    payload = JSON.parse(received.payload);
                    title = "Yeni Sipariş"
                    content = "Sisteme yeni sipariş kaydı gelmiştir.";
                    break;
                case globalConstant.listenerTypes.newcustomer:
                    actionType = actionTypes.ON_NEWCUSTOMER_LISTENER;
                    payload = JSON.parse(received.payload);

                    title = "Yeni Müşteri"
                    content = "Sisteme yeni müşteri kaydı gelmiştir.";

                    break;
                case globalConstant.listenerTypes.newrequest:
                    actionType = actionTypes.ON_REQUEST_INFORMATION_LISTENER;
                    payload = JSON.parse(received.payload);

                    var customerNumber = payload.sourcePhone;
                    var customerName = payload.customername;
                    title = "Bilgi Talebi"
                    content = `${customerNumber} Numaralı ${customerName} Adlı kullanıcı bilgi talebinde bulundu`;

                    break;
                case globalConstant.listenerTypes.newBook:
                    actionType = actionTypes.ON_RESERVATION_LISTENER;
                    payload = JSON.parse(received.payload);

                    title = "Yeni Müşteri"
                    content = "Sisteme yeni müşteri kaydı gelmiştir.";

                    break;
                // case globalConstant.listenerTypes.newstamp:
                //     actionType = actionTypes.STAMP_LISTENER;
                //     payload = JSON.parse(received.payload);
                //     title = "Damga"
                //     content = `Damga Bilgisi Geldi`;
                //     break;
                default:
                    break;
            }
            if (title.length > 0) {
                notification.success({
                    message: title,
                    description: content,
                    placement: "topRight",
                });
            }



            if (actionType == actionTypes.ON_CHAT_LISTENER) {
                var text = payload?.message?.text || "";
                if (payload?.message?.type == MESSAGE_TYPES.QUICK_REPPLY) {
                    text = payload?.message?.content?.header || text;
                }
                if (payload?.message?.type == MESSAGE_TYPES.LIST) {
                    text = payload?.message?.title || text;
                }
                if (payload?.message?.type == MESSAGE_TYPES.FILE) {
                    text = payload?.message?.filename || "Dosya";
                }
                payload.lastWrittenMessage = text;

                const customerNumber = resolveChatCustomerNumber(payload);
                const traceId = ensureChatTraceId(payload, customerNumber);
                payload.customerNumber = customerNumber;

                chatTrace("listener.chat.normalized", {
                    traceId,
                    listenerType,
                    customerNumber,
                    sendType: payload.sendType,
                    messageType: payload?.message?.type,
                    source: payload.source,
                    destination: payload.destination,
                    sourcePhone: payload.sourcePhone,
                    hasStatusFields:
                        payload.hasOwnProperty('isOpenTransaction') ||
                        payload.hasOwnProperty('isOpenAdmin') ||
                        payload.hasOwnProperty('activityId') ||
                        payload.hasOwnProperty('activityName')
                });

                const activeNumber = getState().chatDetailReducer.customerNumber;
                dispatch({
                    type: actionTypes.CHAT_MASTER_UPDATE_PREV_TEXT,
                    newText: text,
                    customerNumber,
                    activeNumber,
                    traceId,
                    messageDate: payload.messageDate,
                    messageTime: payload.messageTime,
                    moveToTop: true
                })

                chatTrace("listener.chat.master-update-dispatched", {
                    traceId,
                    customerNumber,
                    activeNumber,
                    moveToTop: true
                });

                // Eğer aktif sohbet ise mesaj detaylarını güncelle
                if (activeNumber && activeNumber === customerNumber) {
                    const userToken = localStorage.getItem("auth_token");
                    chatTrace("listener.chat.detail-refresh", {
                        traceId,
                        customerNumber,
                        activeNumber
                    });
                    selectChatDetailList({ userToken, customerNumber: activeNumber }, false)(dispatch, getState);
                }

                const chatList = getState().chatReducer?.chatList || [];
                const conversationExists = chatList.some(chat => chat.customerNumber == customerNumber);

                chatTrace("listener.chat.sidebar-lookup", {
                    traceId,
                    customerNumber,
                    conversationExists,
                    chatListLength: chatList.length
                });

                if (!conversationExists && customerNumber) {
                    // Fetch once when an unknown conversation arrives to hydrate full metadata.
                    chatTrace("listener.chat.sidebar-hydrate", {
                        traceId,
                        customerNumber,
                        reason: "conversation_not_found"
                    }, "warn");
                    selectChatList({}, false)(dispatch, getState);
                }
                
                // Debug: Payload'ı kontrol et
                
                // Payload'da işlem durumu bilgileri varsa direkt güncelle
                if (payload.hasOwnProperty('isOpenTransaction') || payload.hasOwnProperty('isOpenAdmin') || 
                    payload.hasOwnProperty('activityId') || payload.hasOwnProperty('activityName')) {
                    
                    
                    dispatch({
                        type: actionTypes.UPDATE_CHAT_ITEM_STATUS,
                        customerNumber,
                        traceId,
                        isOpenTransaction: payload.isOpenTransaction,
                        isOpenAdmin: payload.isOpenAdmin,
                        activityId: payload.activityId,
                        activityName: payload.activityName
                    });

                    chatTrace("listener.chat.status-dispatched", {
                        traceId,
                        customerNumber,
                        statusSource: "payload",
                        isOpenTransaction: payload.isOpenTransaction,
                        isOpenAdmin: payload.isOpenAdmin,
                        activityId: payload.activityId,
                        activityName: payload.activityName
                    });
                } else {
                    
                    // Mesaj tipine göre durumları tahmin et
                    let estimatedIsOpenTransaction = false;
                    let estimatedIsOpenAdmin = false;
                    
                    // Eğer gelen mesaj admin'den ise
                    if (payload.sendType === 2) { // Outbound mesaj (admin gönderdi)
                        estimatedIsOpenAdmin = true;
                        estimatedIsOpenTransaction = true;
                    } 
                    // Eğer gelen mesaj müşteriden ise
                    else if (payload.sendType === 1) { // Inbound mesaj (müşteri gönderdi)
                        estimatedIsOpenTransaction = true;
                        estimatedIsOpenAdmin = false;
                    }
                    
                    // Tahmin edilen durumları güncelle
                    dispatch({
                        type: actionTypes.UPDATE_CHAT_ITEM_STATUS,
                        customerNumber,
                        traceId,
                        isOpenTransaction: estimatedIsOpenTransaction,
                        isOpenAdmin: estimatedIsOpenAdmin,
                        activityId: undefined, // Mevcut değeri koru
                        activityName: undefined // Mevcut değeri koru
                    });

                    chatTrace("listener.chat.status-dispatched", {
                        traceId,
                        customerNumber,
                        statusSource: "estimated",
                        sendType: payload.sendType,
                        isOpenTransaction: estimatedIsOpenTransaction,
                        isOpenAdmin: estimatedIsOpenAdmin
                    });
                }
            }

            if (actionType == actionTypes.STAMP_LISTENER) {
                var stampData = payload
                dispatch({
                    type: actionTypes.STAMP_LISTENER,
                    newData:stampData,
                    
                })
            }


            dispatch({
                type: actionType,
                payload: payload
            })

            if (actionType) {
                chatTrace("listener.final-dispatch", {
                    actionType,
                    listenerType,
                    traceId: payload?.traceId || ""
                });
            }
        } catch (error) {
            chatTrace("listener.error", {
                listenerType: received?.type,
                error: error?.message || error
            }, "error");
        }
    }
};




